<template>
    <base-svg :name="fileIcon" />
</template>

<script setup>
import { BaseSvg } from "@/Components";
import { computed } from "vue";

const props = defineProps({
    file: {
        type: Object,
        required: true,
    },
});

const fileIcon = computed(() => {
    const type = props.file.type;

    if (type.includes("image")) {
        return "image";
    } else if (type.includes("pdf")) {
        return "pdf";
    } else if (type.includes("zip")) {
        return "folder-zip";
    } else if (type.includes("document")) {
        return "document";
    } else {
        return "file";
    }
});
</script>
